import React from "react";
import Audit from "../components/Audit";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Packages from "../components/Packages";
import TSS from "../components/TSS";
import TSSBenifits from "../components/TSSBenifits";;


export default function Home() {
    return (
        <>
            <Hero />
            <Services />
            <Packages />  
            <TSS />
            <TSSBenifits />
            <Audit />
        </>
    );
}